import { render } from "./ToolsManagement.vue?vue&type=template&id=7b422d58&scoped=true"
import script from "./ToolsManagement.vue?vue&type=script&lang=js"
export * from "./ToolsManagement.vue?vue&type=script&lang=js"

import "./ToolsManagement.vue?vue&type=style&index=0&id=7b422d58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b422d58"]])

export default __exports__